import { Component, OnInit, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { SNACK_BAR_DATA, CustomSnackBarService } from './snack-bar.service';

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SnackBarComponent implements OnInit {
  public data: any;
  public snackBarRef: any;

  constructor(
    @Optional() @Inject(SNACK_BAR_DATA) injectedData: any,
    private customSnackBarService: CustomSnackBarService
  ) {
    console.log('Constructor injectedData:', injectedData);
    this.data = injectedData;
    this.snackBarRef = {
      dismiss: () => this.customSnackBarService.dismiss()
    };
  }
  
  durationInSeconds = 50;
  
  get displayMessage(): string {
    const message = this.data?.message || '';
    const orderId = this.data?.orderId || '';
    
    if (orderId && !message.includes(orderId)) {
      return `${message} ${orderId}`;
    }
    return message;
  }

  ngOnInit() {
    console.log('SnackBar data:', this.data);
  }

  copyToClipboard(){
    if (this.data?.orderId) {
      var input = document.createElement('textarea');
      input.innerHTML = this.data.orderId;
      document.body.appendChild(input);
      input.select();
      var result = document.execCommand('copy');
      document.body.removeChild(input);
      return result;
    }
    return false;
  }

}